import {AnEvent} from '../event-kit'

export class PolicyDocSent extends AnEvent {
    public policyId: string
    constructor(from: PolicyDocSent) {
        super()
        Object.assign(this, from)
    }
}
